const ApiErrorCodes = {
  CONTRACT_CONTRACTVALUEBELOWREQUIRED: 'CONTRACT_CONTRACTVALUEBELOWREQUIRED',
};

export default ApiErrorCodes;
